import React from 'react';
import { Box } from '@mui/material';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { State } from '../redux';

const MaximumFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type ComponentState = State['awardConfiguration']['externalPointAward'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  fieldDisabled: (field: Fields) => boolean;
};

const ExternalPointAward: React.FC<Props> = (props) => {
  const { fieldDisabled, maximum } = props;

  return (
    <Box>
      <Box my={4}>
        <MaximumFormInput
          id='maximum'
          label='Maximum'
          readonly={fieldDisabled('maximum')}
          type='text'
          value={maximum}
          required={true}
        />
      </Box>
    </Box>
  );
};

export { ExternalPointAward };
